export default "<p>\r\n  Welcome {{profile?.displayName}}\r\n</p>\r\n"